import React from 'react';

export default function TestimonialCarousel(props) {
    // const testimonials = props.testimonials || '';
    // const testimonials = Array.isArray(props.testimonials) ? props.testimonials : [];
    const { testimonials } = props || {};

    if (!testimonials) {
        return (
            <div className="testimonial-con mt-0 mt-md-5">
                <div className="row g-0">
                    <div className="col-0 col-sm-0 col-md-0 col-lg-2 col-xl-2"></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                        <p>No testimonials available.</p>
                    </div>
                    <div className="col-0 col-sm-0 col-md-0 col-lg-2 col-xl-2"></div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='testimonial-con mt-0 mt-md-5 container'>
                <div className="row g-0">
                    <div className="col-0 col-sm-0 col-md-0 col-lg-2 col-xl-2"></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                        <div id="carouselExampleInterval" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                {testimonials.map((testimonial, index) => (
                                    <div key={`testimonial-${index}`} className={`carousel-item ${index === 0 ? 'active' : ''}`} data-bs-interval="3000">
                                        <div className="row g-0"> 
                                            <div className='carosal-cus-title'>Testimonial</div>
                                            <div className='carosal-cus-sub-title d-none d-lg-block'>Trusted from</div>
                                            <div className='carosal-cus-sub-title d-none d-lg-block'>our clients</div>
                                        </div>
                                        <div className="row g-0">
                                            <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                                                <img src={testimonial.profileImgUrl} className="cus-carousel-img" alt="lurantech testimonial" />
                                            </div>
                                            <div className="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"> 
                                                <div className='custom-quote-img'>
                                                    <img src='/images/testimonial/quote.svg' alt="quote-logo" />
                                                </div>
                                                <div className='custom-quote-text'>{testimonial.quote}</div>
                                                <div className="carousel-capation-custom">
                                                    <div className="custom-carousel-title">{testimonial.name}</div>
                                                    <div className="custom-carousel-description">{testimonial.position}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <button className="carousel-control-prev d-none d-lg-flex" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true">&#8592;</span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next d-none d-lg-flex" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true">&#8594;</span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <div className="col-0 col-sm-0 col-md-0 col-lg-2 col-xl-2"></div>
                </div>
            </div>
        </>
    )
};
